/**
 * @Author:daihua
 * @Date: 2022-4-13
 */

export default {
	path: 'boosWhiteList',
	component: () => import( /* webpackChunkName: "taskBillWhitelist" */ '@/pages/boosWhiteList/index'),
	meta: {
		title: '董监高列表查询'
	},
}